import { render, staticRenderFns } from "./clients.vue?vue&type=template&id=5a7dcb84&"
import script from "./clients.ts?vue&type=script&lang=ts&"
export * from "./clients.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports